var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "markdown-renderer" }, [
    _vm.outputType === "html"
      ? _c("div", { domProps: { innerHTML: _vm._s(_vm.renderedContent) } })
      : _c("pre", [_vm._v(_vm._s(_vm.renderedContent))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }